module.exports = __webpack_public_path__ + "media/mypage/images/icons/credit-cards/mastercard-c4b1dcb1b2c2a91a7ef9e5147d371504.png";